// "Change" and "difference" are considered synonymous.

enum ChangeEnum {
  IncreaseLarge,
  IncreaseModerate,
  NoChange,
  DecreaseModerate,
  DecreaseLarge,
}

export default ChangeEnum;
